// Display labels for the trait keys the platform stores. The keys are the backoffice catalogue keys
// (`KenmerkCatalogus`); the two sites render them differently — DierMatch as a checklist ("Kan met
// honden ✓"), ikzoekbaas as a "label : answer" table — but both need the same Dutch label, so it
// lives here once.
//
// The first seven are the keys epic-7 shipped; the rest arrived with epic-8, when the platform
// widened acceptance from 7 keys to the full 16 the ikzoekbaas questionnaire asks. An unknown key
// still falls back to a humanised form, so a future backoffice key renders something sensible
// instead of a SCREAMING_SNAKE string.

const KENMERK_LABELS: Record<string, string> = {
  KAN_BIJ_KINDEREN: "Kan met kinderen",
  KAN_BIJ_HONDEN: "Kan met honden",
  KAN_BIJ_KATTEN: "Kan met katten",
  ZINDELIJK: "Zindelijk",
  AAN_DE_LIJN: "Loopt aan de lijn",
  VACHTVERZORGING: "Vachtverzorging nodig",
  SPECIALE_ZORG: "Heeft speciale zorg nodig",
  MOET_BIJ_SOORTGENOTEN: "Moet bij soortgenoten",
  GECASTREERD_GESTERILISEERD: "Gecastreerd/gesteriliseerd",
  KAN_ALLEEN_THUISBLIJVEN: "Kan alleen thuisblijven",
  KAN_MEE_IN_DE_AUTO: "Kan mee in de auto",
  BASIS_COMMANDOS: "Kent basiscommando's",
  WAAKSHEID: "Waaksheid",
  SCHOFTHOOGTE: "Schofthoogte",
  KAN_LOSLOPEN: "Kan loslopen",
  BESCHIKBAARHEID: "Beschikbaarheid",
};

export function kenmerkLabel(key: string): string {
  return (
    KENMERK_LABELS[key] ??
    key.charAt(0).toUpperCase() + key.slice(1).toLowerCase().replace(/_/g, " ")
  );
}
